import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=6095dc11&lang=pug"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CsnpConditions: require('/home/docker/code/frontend/components/CsnpConditions.vue').default,CurrentPlansNotice: require('/home/docker/code/frontend/components/CurrentPlansNotice.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,PlanCard: require('/home/docker/code/frontend/components/PlanCard.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
